__turbopack_context__.v({
  "appNumber": "extracted-module__-ZdguG__appNumber",
  "backBtn": "extracted-module__-ZdguG__backBtn",
  "brandInfo": "extracted-module__-ZdguG__brandInfo",
  "brandName": "extracted-module__-ZdguG__brandName",
  "card": "extracted-module__-ZdguG__card",
  "container": "extracted-module__-ZdguG__container",
  "descText": "extracted-module__-ZdguG__descText",
  "description": "extracted-module__-ZdguG__description",
  "detailItem": "extracted-module__-ZdguG__detailItem",
  "detailsGrid": "extracted-module__-ZdguG__detailsGrid",
  "empty": "extracted-module__-ZdguG__empty",
  "grid": "extracted-module__-ZdguG__grid",
  "header": "extracted-module__-ZdguG__header",
  "headerRow": "extracted-module__-ZdguG__headerRow",
  "label": "extracted-module__-ZdguG__label",
  "loading": "extracted-module__-ZdguG__loading",
  "logo": "extracted-module__-ZdguG__logo",
  "logoContainer": "extracted-module__-ZdguG__logoContainer",
  "placeholderLogo": "extracted-module__-ZdguG__placeholderLogo",
  "subtitle": "extracted-module__-ZdguG__subtitle",
  "title": "extracted-module__-ZdguG__title",
  "titleRow": "extracted-module__-ZdguG__titleRow",
  "value": "extracted-module__-ZdguG__value",
});
